module.exports = __webpack_public_path__ + "img/American_Credit_Team_Customer_Voice.495c2ac.png";